import { createReducer, on } from '@ngrx/store';

import { SortOrder } from '@common/utils/search-sort';
import { AvailableTabsOnPage, LastPageStateWithTabs } from '@store/types/basic-last-page-state';

import {
  addGeozone,
  changeAllGeozonesVisibleOnMap,
  changeGeozoneGroupsToVisibleOnMap,
  changeGeozoneToVisibleOnMap,
  deleteGeozoneById,
  hardChangeGeozoneToVisibleOnMap,
  initGeozonesVisibleOnMap,
  setGeozonesLoading,
  setLastPageStateGeozones,
  storeGeozones,
  storeGeozonesObjectsCount,
  updateGeozoneById,
} from './geozones.actions';

export interface GeozonesState {
  loading: boolean;
  list: any[];
  lastPageState: LastPageStateWithTabs;
  visibleOnMap: Record<number, boolean>;
  geozonesObjectsCount: Record<number, number>;
}

export const initialStateGeozones: GeozonesState = {
  loading: false,
  list: [],
  lastPageState: {
    activeTabOnPage: AvailableTabsOnPage.List,
    [AvailableTabsOnPage.List]: {
      searchValue: '',
      sortOrder: SortOrder.Asc,
    },
    [AvailableTabsOnPage.Groups]: {
      searchValue: '',
      sortOrder: SortOrder.Asc,
      openedGroupIds: [],
      isOpenedFreeList: false,
    },
  },
  visibleOnMap: {},
  geozonesObjectsCount: {},
};

const compareKeys = (obj1: Record<number, any>, obj2: Record<number, any>) => {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  const set2 = new Set(keys2);

  for (const key of keys1) {
    if (!set2.has(key)) return false;
  }

  return true;
};

export const geozonesReducer = createReducer(
  initialStateGeozones,
  on(storeGeozones, (state, { list }) => ({ ...state, list })),

  on(setGeozonesLoading, (state, { loading }) => ({
    ...state,
    loading,
  })),

  on(setLastPageStateGeozones, (state, { newPageState }) => {
    return {
      ...state,
      lastPageState: {
        ...state.lastPageState,
        ...newPageState,
      },
    };
  }),

  on(updateGeozoneById, (state, data) => {
    const { updatedGeozone, params } = data;
    const list = state.list.map((geozone: any) => {
      return geozone.id === updatedGeozone.id ? { ...geozone, ...updatedGeozone } : geozone;
    });

    return { ...state, list };
  }),

  on(addGeozone, (state, data) => {
    const { createdGeozone, params } = data;
    const existingcreatedGeozone = state.list.find((obj: any) => obj.id === createdGeozone.id);

    if (!existingcreatedGeozone) {
      const newList = [createdGeozone, ...state.list];
      return {
        ...state,
        list: newList,
      };
    }

    return state;
  }),
  on(deleteGeozoneById, (state, data) => {
    const { deletedGeozoneId } = data;
    return {
      ...state,
      list: state.list.filter((geozone: any) => geozone.id !== deletedGeozoneId),
    };
  }),

  on(initGeozonesVisibleOnMap, (state, data) => {
    const { visibleOnMap } = data;

    if (compareKeys(state.visibleOnMap, visibleOnMap)) {
      return state;
    }

    return {
      ...state,
      visibleOnMap,
    };
  }),

  on(hardChangeGeozoneToVisibleOnMap, (state, data) => {
    const { geozoneId, isVisible } = data;
    const currentVisibleOnMap = { ...state.visibleOnMap };

    if (isVisible) {
      currentVisibleOnMap[geozoneId] = true;
    } else {
      delete currentVisibleOnMap[geozoneId];
    }

    return {
      ...state,
      visibleOnMap: currentVisibleOnMap,
    };
  }),

  on(changeGeozoneToVisibleOnMap, (state, data) => {
    const { geozoneId } = data;
    const currentVisibleOnMap = { ...state.visibleOnMap };

    if (geozoneId in currentVisibleOnMap) {
      delete currentVisibleOnMap[geozoneId];
    } else {
      currentVisibleOnMap[geozoneId] = true;
    }

    return {
      ...state,
      visibleOnMap: currentVisibleOnMap,
    };
  }),
  on(changeGeozoneGroupsToVisibleOnMap, (state, data) => {
    const { ids, stateAll } = data;
    const currentVisibleOnMap = { ...state.visibleOnMap };

    ids.forEach((key: number) => {
      if (stateAll) {
        currentVisibleOnMap[key] = true;
      } else {
        delete currentVisibleOnMap[key];
      }
    });
    return {
      ...state,
      visibleOnMap: currentVisibleOnMap,
    };
  }),

  on(changeAllGeozonesVisibleOnMap, (state, data) => {
    const { stateAll } = data;
    let currentVisibleOnMap: Record<number, boolean> = {};

    if (stateAll) {
      currentVisibleOnMap = state.list.reduce((acc, item) => {
        acc[item.id] = true;
        return acc;
      }, {});
    }

    return {
      ...state,
      visibleOnMap: currentVisibleOnMap,
    };
  }),

  on(storeGeozonesObjectsCount, (state, { geozonesObjectsCount }) => ({
    ...state,
    geozonesObjectsCount: {
      // ...state.geozonesObjectsCount,
      ...geozonesObjectsCount,
    },
  })),
);
